import React, {Component} from 'react';
import Alert from 'react-s-alert';
import PreloaderDog from './PreloaderDog';

class AlertsConteiner extends Component {
    constructor(props) {
        super(props);
        this.renderWhastsapp = this.renderWhastsapp.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
    }
    
    handleConfirm() {
        console.log('Customer confirmation!');
        Alert.close(this.props.id);
    }
    
    renderWhastsapp() {
        return this.props.customFields.colaboradores.map((colab, index) => {
            const href = "https://api.whatsapp.com/send?phone=+" + colab.telefono + "&text=" + this.props.customFields.messageWhatsApp + " " + this.props.customFields.urlWhatsApp;
            return (
                <a key={index} href={href}
                   target="_blank" className="btn btn-block btn-lg btn-whastapp">
                    <span>{colab.nombre + ": " + colab.telefono}</span>
                </a>
            );
        })
    }
    
    render() {
        let classNameAlert = this.props.classNames;
        if (this.props.customFields.messageItem === 3) {
            classNameAlert += " s-alert-top-right-grand";
        }
        
        if (this.props.customFields.modal) {
            classNameAlert += " s-alert-box-modal"
        }
       
        return (
            <div className={classNameAlert} id={this.props.id} style={this.props.styles}>
                {this.props.customFields.messageItem === 1 &&
                    <div className='s-alert-box-inner'>
                        {this.props.message}
                        <PreloaderDog/>
                        {this.props.customFields.messageWait}
                    </div>
                }
                {this.props.customFields.messageItem === 2 &&
                    <div className='s-alert-box-inner'>
                        <span className={this.props.customFields.icon}></span>
                        {this.props.message}
                    </div>
                }
                {this.props.customFields.messageItem === 3 &&
                    <div className='s-alert-box-inner'>
                        <span className={this.props.customFields.icon}></span>
                        {this.props.message}
                    </div>
                }
                {this.props.customFields.messageItem === 4 &&
                    <div className='s-alert-box-inner'>
                        <span className={this.props.customFields.icon}></span>
                        {this.props.message}
                        <hr/>
                        {this.renderWhastsapp()}
                    </div>
                }
                {this.props.customFields.showIconClosed &&
                    <span className='s-alert-close' onClick={this.props.handleClose}></span>
                }
            </div>
        )
    }
    
    componentDidMount() {
        
        // var svg = document.getElementById("scottie-loader");
        //var s = Snap(svg);
        // var eyelid = Snap.select('.eyelid');
        // var leftEar = Snap.select('.left-ear');
        // var rightEar = Snap.select('.right-ear');
        // blink();
        // twitchRightStart();
        // twitchLeftStart();
        
        // function blink() {
        //     setTimeout(function () {
        //         if (eyelid !== null) {
        //             eyelid.animate({d: "M85.89 68.876l24.72-16.19 17.96 27.423-24.72 16.188z"}, 150, mina.easeinout, endBlink);
        //         }
        //     }, 3000);
        // }
        //
        // function endBlink() {
        //     if (eyelid !== null) {
        //         eyelid.animate({d: "M85.88 68.878l24.722-16.19 1.802 2.754-24.72 16.19z"}, 150, mina.easeinout, blink);
        //     }
        // }
        //
        // function twitchRightStart() {
        //     setTimeout(function () {
        //         if (rightEar !== null) {
        //             rightEar.animate({transform: 'r15,66,93'}, 300, mina.easein, twitchRightEnd);
        //         }
        //     }, 2500);
        // }
        //
        // function twitchRightEnd() {
        //     setTimeout(function () {
        //         if (rightEar !== null) {
        //             rightEar.animate({transform: 'r0,66,93'}, 100, mina.elastic, twitchRightStart);
        //         }
        //     }, 50);
        // }
        //
        // function twitchLeftStart() {
        //     setTimeout(function () {
        //         if (leftEar !== null) {
        //             leftEar.animate({transform: 'r-10,71,78'}, 300, mina.easein, twitchLeftEnd);
        //         }
        //     }, 2100);
        // }
        //
        // function twitchLeftEnd() {
        //     setTimeout(function () {
        //         if (leftEar !== null) {
        //             leftEar.animate({transform: 'r0,71,78'}, 200, mina.elastic, twitchLeftStart);
        //         }
        //     }, 50);
        // }
    }
}

export default AlertsConteiner;